import { commonConstants, paymentConstants } from '../_constants';
export function transcation(state = {}, action) {
  switch (action.type) {
    case commonConstants.TRANSCATION_REQUEST:
      return {
        ...state,
        transcation: false,
        data: action.transcation?.data,
      };
    case commonConstants.TRANSCATION_SUCCESS:
      return {
        ...state,
        transcation: true,
        data: action.transcation?.data?.response,
      };
    case commonConstants.TRANSCATION_FAILURE:
      return {
        ...state,
        transcation: false,
        data: action.transcation?.data,
      };
    default:
      return state;
  }
}

export function getValidID(state = {}, action) {
  switch (action.type) {
    case commonConstants.TRANSCATION_REQUEST:
      return {
        ...state,
        transcation: false,
        data: action.transcation.data,
      };
    case commonConstants.TRANSCATION_SUCCESS:
      return {
        ...state,
        transcation: true,
        data: action.transcation.data.response,
      };
    case commonConstants.TRANSCATION_FAILURE:
      return {
        ...state,
        transcation: false,
        data: action.transcation.data,
      };
    default:
      return state;
  }
}

export function receivedCurr(state = {}, action) {
  switch (action.type) {
    case commonConstants.RECEIVED_CURRENCY:
      return {
        ...state,
        data: action.curr,
      };
    default:
      return state;
  }
}

export function lastPage(state = {}, action) {
  switch (action.type) {
    case commonConstants.LAST_PAGE:
      return {
        ...state,
        lastPage: action.payload,
      };
    default:
      return state;
  }
}

export function paymentMode(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_PAYMENT_MODE_REQUEST:
      return {
        ...state,
        paymentMode: true,
        data: action.paymentMode.data,
      };
    case paymentConstants.GET_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        paymentMode: true,
        data: action.paymentMode.data.response,
      };
    case paymentConstants.GET_PAYMENT_MODE_FAILURE:
      return {
        ...state,
        paymentMode: false,
        data: action.paymentMode.data,
      };
    default:
      return state;
  }
}
export function purpose(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_PURPOSE_REQUEST:
      return {
        ...state,
        purpose: true,
        data: action.purpose.data,
      };
    case paymentConstants.GET_PURPOSE_SUCCESS:
      return {
        ...state,
        purpose: true,
        data: action.purpose.data.response,
      };
    case paymentConstants.GET_PURPOSE_FAILURE:
      return {
        ...state,
        purpose: false,
        data: action.purpose.data,
      };
    default:
      return state;
  }
}

export function source(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_SOURCE_REQUEST:
      return {
        ...state,
        source: true,
        data: action.source.data,
      };
    case paymentConstants.GET_SOURCE_SUCCESS:
      return {
        ...state,
        source: true,
        data: action.source.data.response,
      };
    case paymentConstants.GET_SOURCE_FAILURE:
      return {
        ...state,
        source: false,
        data: action.source.data,
      };
    default:
      return state;
  }
}

export function saveRemit(state = {}, action) {
  switch (action.type) {
    case paymentConstants.SAVE_REMIT_REQUEST:
      return {
        ...state,
        saveRemit: false,
        data: action.saveRemit.data,
      };
    case paymentConstants.SAVE_REMIT_SUCCESS:
      return {
        ...state,
        saveRemit: true,
        data: action.saveRemit.data,
      };
    case paymentConstants.NET_AMT:
      return {
        ...state,
        netAmt: action.data,
      };
    case commonConstants.CLEAR_PREVIOUS_TRANSFER_MESSAGE:
      return {
        ...state,
        data: action.payload,
      };
    case paymentConstants.SAVE_REMIT_FAILURE:
      return {
        ...state,
        saveRemit: false,
        data: action.saveRemit.data,
      };
    case paymentConstants.SAVE_TO_CURRENCY:
      return {
        ...state,
        toCurrency: action.payload,
      };
    default:
      return state;
  }
}

export function getTransferRate(state = {}, action) {
  switch (action.type) {
    case paymentConstants.TRANSFER_RATE:
      return {
        ...state,
        transferRate: action.data.rate,
        transferCharges: action.data.charges,
      };
    default:
      return state;
  }
}

export function getTransactionRef(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_TRANSACTION_SEARCH_REF_REQUEST:
      return {
        ...state,
        getTranscation: false,
        loading: true,
        data: action.getTranscation.data,
      };
    case paymentConstants.GET_TRANSACTION_SEARCH_REF_SUCCESS:
      return {
        ...state,
        getTranscation: true,
        loading: false,
        data: action.getTranscation.data.response,
      };
    case paymentConstants.GET_TRANSACTION_SEARCH_REF_FAILURE:
      return {
        ...state,
        loading: false,
        getTranscation: false,
        data: action.getTranscation.data,
      };
    case paymentConstants.TRANSFER_RATE:
      return {
        ...state,
        transferRate: action.data,
        loading: false,
      };
    case paymentConstants.CLEAR_TRANS_INFO:
      return {
        ...state,
        data: action.payload,
        loading: null,
      };
    case paymentConstants.CLEAR_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}

export function cancelTransaction(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_TRANSACTION_CANCEL_REQUEST:
      return {
        ...state,
        cancelTranscation: false,
        data: action.cancelTranscation?.data,
      };
    case paymentConstants.GET_TRANSACTION_CANCEL_SUCCESS:
      return {
        ...state,
        cancelTranscation: true,
        data: action.cancelTranscation.data,
      };
    case paymentConstants.GET_TRANSACTION_CANCEL_FAILURE:
      return {
        ...state,
        cancelTranscation: false,
        data: action.cancelTranscation.data,
      };
    default:
      return state;
  }
}

export function getDrawingBank(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_DRAWING_BANK_REQUEST:
      return {
        ...state,
        drawingBank: false,
        data: action.drawingBank?.data,
      };
    case paymentConstants.GET_DRAWING_BANK_SUCCESS:
      return {
        ...state,
        drawingBank: true,
        data: action.drawingBank?.data.response,
      };
    case paymentConstants.GET_DRAWING_BANK_FAILURE:
      return {
        ...state,
        drawingBank: false,
        data: action.drawingBank?.data,
      };
    default:
      return state;
  }
}
